import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 15l3 -3l3 3","key":"svg-0"}],["path",{"d":"M9 11l3 -3l3 3","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}]]

const IconCircleChevronsUp = createReactComponent('outline', 'circle-chevrons-up', 'CircleChevronsUp', __iconNode);

export default IconCircleChevronsUp;